<div class="page-container" testId="tenant-authentication-page">
  <div class="page-shell" testId="tenant-authentication-shell">
    <div class="page-toolbar" testId="tenant-authentication-toolbar">
      <div class="page-heading" testId="tenant-authentication-heading">
        <h3 class="page-title" testId="tenant-authentication-title">{{ 'tenant.certification.title' | i18n: '认证信息' }}</h3>
      </div>
      <div class="header-actions" *ngIf="canEdit" testId="tenant-authentication-header-actions">
        <button
          nz-button
          nzType="primary"
          class="submit-button"
          [nzLoading]="submitting"
          (click)="submit()"
          testId="tenant-authentication-submit-button"
        >
          {{ 'tenant.certification.submit' | i18n: '提交认证' }}
        </button>
      </div>
    </div>

    <div class="form-container" testId="tenant-authentication-form-container">
      <div class="auth-settings-container" testId="tenant-authentication-settings-container">
        <div class="settings-surface" testId="tenant-authentication-settings-surface">
          <section class="section-card status-section" testId="tenant-authentication-status-section">
            <div class="section-header">
              <h4 class="section-title">
                <span class="section-kicker"><i nz-icon nzType="safety-certificate" nzTheme="outline"></i></span>
                {{ 'tenant.certification.status' | i18n: '认证状态' }}
              </h4>
            </div>

            <div class="status-bar" testId="tenant-authentication-status-bar">
              <div class="status-info">
                <span
                  class="status-pill"
                  [class.pending]="!certificateStatus || certificateStatus === 'Audit'"
                  [class.approved]="certificateStatus === 'Audited'"
                  [class.rejected]="certificateStatus === 'Back'"
                  testId="tenant-authentication-status-pill"
                >
                  {{
                    !certificateStatus
                      ? ('tenant.certification.pending' | i18n: '未提交')
                      : certificateStatus === 'Audit'
                        ? ('tenant.certification.audit' | i18n: '待审核')
                        : certificateStatus === 'Audited'
                          ? ('tenant.certification.audited' | i18n: '已通过')
                          : ('tenant.certification.back' | i18n: '已拒绝')
                  }}
                </span>
              </div>
              <div class="status-note" *ngIf="certificateStatus === 'Back' && certificateFailReason">
                <span class="status-note-label">{{ 'tenant.certification.fail-reason' | i18n: '拒绝原因' }}</span>
                <span class="status-note-value">{{ certificateFailReason }}</span>
              </div>
            </div>
          </section>

          <section class="section-card form-section" testId="tenant-authentication-form-section">
            <div class="section-header">
              <h4 class="section-title">
                <span class="section-kicker"><i nz-icon nzType="profile" nzTheme="outline"></i></span>
                {{ 'tenant.certification.title' | i18n: '认证信息' }}
              </h4>
            </div>

            <div class="form-grid">
              <div class="form-field">
                <label class="form-label"><span class="required-star">*</span>{{ 'tenant.certification.tenant-name' | i18n }}</label>
                <input
                  nz-input
                  [(ngModel)]="tenantName"
                  [disabled]="!canEdit"
                  [placeholder]="'tenant.certification.tenant-name' | i18n"
                  testId="tenant-authentication-tenant-name-input"
                />
                <div class="error-tip" *ngIf="showErrors && !tenantName?.trim()">
                  {{ 'tenant.certification.tenant-name-required' | i18n }}
                </div>
              </div>

              <div class="form-field">
                <label class="form-label"><span class="required-star">*</span>{{ 'tenant.certification.unified-number' | i18n }}</label>
                <input
                  nz-input
                  [(ngModel)]="unifiedNumber"
                  [disabled]="!canEdit"
                  [placeholder]="'tenant.certification.unified-number' | i18n"
                  testId="tenant-authentication-unified-number-input"
                />
                <div class="error-tip" *ngIf="showErrors && !unifiedNumber?.trim()">
                  {{ 'tenant.certification.unified-required' | i18n }}
                </div>
              </div>

              <div class="form-field">
                <label class="form-label"
                  ><span class="required-star">*</span>{{ 'tenant.certification.representative-number' | i18n }}</label
                >
                <input
                  nz-input
                  [(ngModel)]="representativeNumber"
                  [disabled]="!canEdit"
                  [placeholder]="'tenant.certification.representative-number' | i18n"
                  testId="tenant-authentication-representative-number-input"
                />
                <div class="error-tip" *ngIf="showErrors && !representativeNumber?.trim()">
                  {{ 'tenant.certification.representative-required' | i18n }}
                </div>
              </div>
            </div>
          </section>

          <section class="section-card upload-section" testId="tenant-authentication-upload-section">
            <div class="section-header">
              <h4 class="section-title">
                <span class="section-kicker"><i nz-icon nzType="upload" nzTheme="outline"></i></span>
                {{ 'tenant.certification.file' | i18n: '认证文件' }}
              </h4>
              <div class="section-desc">{{ 'tenant.certification.file-desc' | i18n: '请上传认证文件（单文件）' }}</div>
            </div>

            <div class="upload-existing" *ngIf="existingCertificateFileName" testId="tenant-authentication-existing-file">
              <div class="upload-existing-info">
                <span class="upload-existing-label"> {{ 'tenant.certification.current-file' | i18n: '已上传文件' }}： </span>
                <span class="upload-existing-name" title="{{ existingCertificateFileName }}">{{ existingCertificateFileName }}</span>
                <span class="upload-existing-size" *ngIf="existingCertificateFileSizeText"> ({{ existingCertificateFileSizeText }}) </span>
              </div>
              <div class="upload-existing-actions">
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  (click)="previewExistingFile()"
                  [disabled]="!existingCertificatePreviewUrl"
                  testId="tenant-authentication-preview-existing-button"
                >
                  <span nz-icon nzType="eye"></span>
                  {{ 'tenant.certification.preview' | i18n: '预览' }}
                </button>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  (click)="clearExistingFile()"
                  testId="tenant-authentication-clear-existing-button"
                >
                  <span nz-icon nzType="delete"></span>
                  {{ 'tenant.certification.remove' | i18n: '从当前表单移除' }}
                </button>
              </div>
            </div>

            <div class="upload-actions" testId="tenant-authentication-upload-actions">
              <nz-upload
                [nzMultiple]="false"
                [nzBeforeUpload]="beforeUpload"
                [nzShowUploadList]="true"
                [nzFileList]="fileList"
                [nzAccept]="acceptTypes"
                [nzRemove]="removeFile"
                (nzChange)="onUploadChange($event)"
                [nzDisabled]="!canEdit"
                testId="tenant-authentication-upload"
              >
                <button
                  nz-button
                  nzType="primary"
                  class="upload-trigger"
                  [disabled]="!canEdit"
                  testId="tenant-authentication-upload-button"
                >
                  <span nz-icon nzType="upload"></span>
                  {{ 'tenant.certification.upload' | i18n: '上传文件' }}
                </button>
              </nz-upload>
              <div class="upload-tip">
                {{ 'tenant.certification.supports' | i18n: '支持格式：PDF、JPG、PNG、DOC、DOCX，单个文件≤10MB' }}
              </div>
            </div>

            <div class="error-tip" *ngIf="showErrors && !fileList.length">
              {{ 'tenant.certification.file-required' | i18n }}
            </div>
          </section>

          <section class="section-card notes-section" testId="tenant-authentication-notes-section">
            <div class="section-header">
              <h4 class="section-title">
                <span class="section-kicker"><i nz-icon nzType="info-circle" nzTheme="outline"></i></span>
                {{ 'tenant.certification.notes.title' | i18n: '认证说明' }}
              </h4>
            </div>
            <ul class="notes-list">
              <li>{{ 'tenant.certification.notes.1' | i18n: '请上传清晰的认证文件照片或扫描件' }}</li>
              <li>{{ 'tenant.certification.notes.2' | i18n: '认证文件需包含企业名称、统一社会信用代码/身份信息等关键信息' }}</li>
              <li>{{ 'tenant.certification.notes.3' | i18n: '提交后我们会在3个工作日内审核' }}</li>
              <li>{{ 'tenant.certification.notes.4' | i18n: '如需加速，请联系企业客服并提供必要说明' }}</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
